import { useEffect } from 'react';

import storage, { EStorageKey } from '@webtrader/core/storage';
import { checkIsNative } from '@webtrader/core/validators/device';

export const useMarketingPageUrl = () => {
  useEffect(() => {
    if (!checkIsNative() && window.location.search) {
      storage.setItem(EStorageKey.MARKETING_PARAMS, window.location.search);
    }
  }, []);
};
